import SDIcon from '../../SDIcon'

const IconFlagWorld = (props) => (
  <SDIcon title='World' defaultColorKey='contentPrimary' viewBox='0 0 24 24' {...props}>
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <path d="M3 12h18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 3c3.2 3.2 3.2 14.8 0 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 3c-3.2 3.2-3.2 14.8 0 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </SDIcon>
)

export default IconFlagWorld
